import { useState } from 'react';
import CountLink from './CountLink';
import { AllTutorsDialog, TutorListDialog } from './tutorLists';
import { TUTOR_KIND_LABEL, allTutorsUrl, prefetchTutors, tutorCountTutorsUrl } from './tutorCountTutors';

// Makes the tutor counts on the Tutor Count page clickable and owns the popups:
//   const drill = useTutorCountDrilldown(month);
//   { field: 'activeTutors', ..., render: drill.cell('active', 'activeTutors') }     a CRO's tutors (kind: active | new)
//   drill.openAll()                                                                   the company-wide card's list of all tutors
//   ...
//   {drill.dialog}
const useTutorCountDrilldown = (month) => {
  const [open, setOpen] = useState(null);
  const requestFor = (kind, row) => ({ kind, userId: row.entityId, userName: row.entityName, month });

  const cell = (kind, field) => (row) => (row.isBatch ? (
    // the batch (group-class) line is not a CRO - nothing to open
    <span>{row[field] ?? '-'}</span>
  ) : (
    <CountLink
      count={row[field]}
      label={`${TUTOR_KIND_LABEL[kind].toLowerCase()} of ${row.entityName}`}
      onOpen={() => setOpen({ type: 'cro', ...requestFor(kind, row) })}
      onPrefetch={() => prefetchTutors(tutorCountTutorsUrl(requestFor(kind, row)))}
    />
  ));

  const openAll = () => setOpen({ type: 'all', month });
  const prefetchAll = () => prefetchTutors(allTutorsUrl({ month }));

  let dialog = null;
  if (open?.type === 'cro') dialog = <TutorListDialog request={open} onClose={() => setOpen(null)} />;
  if (open?.type === 'all') dialog = <AllTutorsDialog request={open} onClose={() => setOpen(null)} />;
  return { cell, openAll, prefetchAll, dialog };
};

export default useTutorCountDrilldown;
